module.exports = __webpack_public_path__ + "img/SHIB.2273a739.png";